import { AttributeBaseType } from "../../AttributeComponents/AttributeBaseType";
import { ConfigurationComponentType } from "../ConfigurationComponentType";
const baseTypes = Object.values(AttributeBaseType);
/**
 * Build configuration navigation tree from layout
 * @private
 * @param layout
 * @param options
 * @returns
 */
export function buildNavigationFromLayout(layout, options) {
    const items = [];
    return layout.rows.reduce((memo, row) => memo.concat(getNavigationFromLayoutRow(row, options)), items);
}
function getNavigationFromLayoutCell(cell, options) {
    var _a, _b;
    const items = [];
    if (!cell.rows) {
        return items;
    }
    let isGroup = false;
    const childItems = cell.rows.reduce((memo, row) => memo.concat(getNavigationFromLayoutRow(row, options)), []);
    // FIXME: hacky, move to layout and use PluginHelper?
    if (cell.plugin) {
        const layoutNodeId = cell.id;
        const pluginId = cell.plugin.id;
        if (baseTypes.includes(pluginId)) {
            const cellData = (_a = cell.dataI18n) === null || _a === void 0 ? void 0 : _a.default;
            if (cellData) {
                const isVisible = cellData.visibleInNavigation;
                const attributeId = cellData.identifier;
                if (isVisible || options.showAllAttributes)
                    items.push({
                        attributeId,
                        layoutNodeId,
                        pluginId,
                        isComplete: false,
                    });
            }
        }
        if (options.showGroups &&
            pluginId === ConfigurationComponentType.AttributeGroup) {
            const cellData = (_b = cell.dataI18n) === null || _b === void 0 ? void 0 : _b.default;
            if (cellData && childItems.length > 0) {
                const groupId = cellData.title;
                items.push({
                    groupId,
                    layoutNodeId,
                    pluginId,
                    items: childItems,
                    isComplete: false,
                });
                isGroup = true;
            }
        }
    }
    if (!isGroup && childItems.length > 0) {
        items.push(...childItems);
    }
    return items;
}
function getNavigationFromLayoutRow(row, options) {
    const items = [];
    return row.cells.reduce((memo, cell) => memo.concat(getNavigationFromLayoutCell(cell, options)), items);
}
//# sourceMappingURL=buildNavigationFromLayout.js.map